<template>
  <BaseInlineInput>
    <ProjectStatusSelect
      v-model="model"
      :disabled="$attrs.disabled"
      :return-object="false"
      inline
      :filterable="filterable"
      class="disabled-focus"
    >
      <template #prefix>
        <BaseBadge
          v-if="selectedOption"
          :color="selectedOption?.attributes?.color"
        >
          {{ selectedOption?.attributes?.name }}
        </BaseBadge>
        <BaseBadge
          v-else
          color="grey"
        >
          {{ $t('No status') }}
        </BaseBadge>  
      </template>
    </ProjectStatusSelect>
  </BaseInlineInput>
</template>
<script>
import ProjectStatusSelect from "@/modules/projects/components/ProjectStatusSelect.vue";

export default {
  components: {
    ProjectStatusSelect
  },
  props: {
    modelValue: {
      type: [String, Number, Object],
      default: '',
    },
    filterable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showStatusEditDialog: false,
      selectedOption: null
    }
  },
  computed: {
    model: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    statuses() {
      return this.$store.getters['projects/orderedStatuses'] || []
    }
  },
  watch: {
    statuses() {
      this.syncStatus()
    },
    model: {
      immediate: true,
      handler() {
        this.syncStatus()
      }
    }
  },
  methods: {
    syncStatus() {
      this.selectedOption = this.statuses.find(x => x.id?.toString() === this.model?.toString())
    }
  }
}
</script>
